/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListInvoices200ResponseItemsInner
 */
export interface ListInvoices200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ListInvoices200ResponseItemsInner
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    invoiceNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof ListInvoices200ResponseItemsInner
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof ListInvoices200ResponseItemsInner
     */
    end: Date;
    /**
     * 
     * @type {Date}
     * @memberof ListInvoices200ResponseItemsInner
     */
    invoiceDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ListInvoices200ResponseItemsInner
     */
    paid: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListInvoices200ResponseItemsInner
     */
    refusalReason?: string;
}

/**
 * Check if a given object implements the ListInvoices200ResponseItemsInner interface.
 */
export function instanceOfListInvoices200ResponseItemsInner(value: object): value is ListInvoices200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('paid' in value) || value['paid'] === undefined) return false;
    return true;
}

export function ListInvoices200ResponseItemsInnerFromJSON(json: any): ListInvoices200ResponseItemsInner {
    return ListInvoices200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListInvoices200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
        'invoiceNumber': json['invoiceNumber'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'invoiceDate': (new Date(json['invoiceDate'])),
        'paid': json['paid'],
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
    };
}

export function ListInvoices200ResponseItemsInnerToJSON(json: any): ListInvoices200ResponseItemsInner {
    return ListInvoices200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListInvoices200ResponseItemsInnerToJSONTyped(value?: ListInvoices200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'invoiceNumber': value['invoiceNumber'],
        'start': ((value['start']).toISOString()),
        'end': ((value['end']).toISOString()),
        'invoiceDate': ((value['invoiceDate']).toISOString()),
        'paid': value['paid'],
        'refusalReason': value['refusalReason'],
    };
}

